module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_22-c2276ec8f104f63cb6f81dcccb1f3711.png";